import refs from '../helpers/refs'

class CInstructionManualSearch {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-instruction-manual-search')
    .forEach(el => new CInstructionManualSearch(el))
})
